import React from 'react'
import styles from './Counter.module.scss';
import { Control, Controller } from "react-hook-form";

type TProps = {
  control: Control<any, any>;
  name: string;
  min?: number;
  max?: number;
}

export const Counter: React.FC<TProps> = ({ control, name, min = 0, max = 999 }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className={styles.wrapper}>
          <button
            type="button"
            className={styles.button}
            disabled={field.value === min}
            onClick={() => field.onChange(field.value - 1)}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.6673 8.66536H3.33398V7.33203H12.6673V8.66536Z" fill="currentColor"/>
            </svg>
          </button>
          {field.value}
          <button
            type="button"
            className={styles.button}
            disabled={field.value === max}
            onClick={() => field.onChange(field.value + 1)}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.6673 8.66536H8.66732V12.6654H7.33398V8.66536H3.33398V7.33203H7.33398V3.33203H8.66732V7.33203H12.6673V8.66536Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
      )}/>
  )
}
